import React from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  Checkbox,
  TextInput,
  NumberInput,
} from "carbon-components-react";

const BusinessPlanIdeaForm = ({ disabled, register, errors }) => {
  return (
    <FormGroup legendText="3. IDEIA DO NEGÓCIO " className="section-header">
      <h6 className="section-subtitle">
        A ser preenchida por todos/as candidatos/as independentemente se tem ou
        não um negócio actualmente
      </h6>

      <fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="businessIdea"
              labelText="3.1	Descrição da Ideia do Negócio para  o Agora Emprega"
              helperText="[Descreva de forma sumária a sua ideia, destacando as principais características inovadoras/diferenciadoras (científicas, tecnológicas, de mercado, do produto/serviço, processo ou modelo de negócio). Entende-se por inovação/diferenciação qualquer aspecto considerado como novo pelo eventual utilizador/mercado, capaz de garantir diferenciação face aos concorrentes. Use no máximo 400 palavras.]"
              rows={10}
              enableCounter
              disabled={disabled}
              {...register("businessIdea")}
            />
            <p className="field-error">{errors.businessIdea?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required">
        <legend className="bx--label">3.2 Tipo de Negócio para a Ideia</legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Seleccione o tipo de negócio]
            </div>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Fabricante/Produtor "
              id="isManufacturerOrProducer"
              disabled={disabled}
              {...register("isManufacturerOrProducer")}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Prestador de serviço "
              id="isServiceProvider"
              disabled={disabled}
              {...register("isServiceProvider")}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Retalhista "
              id="isRetailer"
              disabled={disabled}
              {...register("isRetailer")}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Grossista/Vendedores a Grosso"
              id="isWholesaler"
              disabled={disabled}
              {...register("isWholesaler")}
            />
          </Column>
          <p className="field-error">{errors.businessType?.message}</p>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <Row>
          <Column sm={12} md={12} lg={12} className="required">
            <TextArea
              id="ideaProductOrService"
              labelText="3.3	Tipo de Produto(s)/Serviço(s) que pretende vender/oferecer na sua Ideia"
              helperText="[Descreva de forma sumária, o(s) produto(s)/serviço(s) que pretende vender/ oferecer na sua ideia de negócio, enunciando as suas principais características, pacotes a oferecer por segmento de clientes e o grau de desenvolvimento. Use no máximo 250 palavras.]"
              rows={8}
              enableCounter
              disabled={disabled}
              {...register("ideaProductOrService")}
            />
            <p className="field-error">
              {errors.ideaProductOrService?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <h6>3.4 Declaração de Missão</h6>
      <fieldset className="bx--fieldset">
        <Row>
          <Column sm={12} md={12} lg={12} className="required">
            <TextArea
              id="mission"
              labelText="3.4.1 Missão"
              helperText="[Indique a missão da sua ideia de negócio no âmbito do Agora Emprega. A missão de uma organização/empresa refere-se à razão pela qual ela existe, i.e., a sua razão de ser, o seu propósito, o que a empresa tem a oferecer. Use no máximo 50 palavras.]"
              rows={2}
              enableCounter
              disabled={disabled}
              {...register("mission")}
            />
            <p className="field-error">{errors.mission?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <Row>
          <Column sm={12} md={12} lg={12} className="required">
            <TextArea
              id="vision"
              labelText="3.4.2 Visão"
              helperText="[Indique a visão da sua ideia de negócio no âmbito do Agora Emprega de forma breve. A visão é a manifestação de para onde a empresa quer chegar e o que pretende se tornar a longo prazo. Use no máximo 50 palavras.]"
              rows={2}
              enableCounter
              disabled={disabled}
              {...register("vision")}
            />
            <p className="field-error">{errors.vision?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <legend className="bx--label">
          3.5 Capital necessário para implementar o Plano de Negócio
        </legend>
        <div className="bx--form__helper-text">
          [Indique o montante total necessário em Meticais (MZN) para a
          implementação do seu Plano de Negócio.]
        </div>
        <Row>
          <Column sm={12} md={4} lg={4} className="required">
            <TextInput
              id="neededCapital"
              labelText="MZN"
              disabled={disabled}
              {...register("neededCapital")}
            />
            <p className="field-error">{errors.neededCapital?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <legend className="bx--label">
          3.6 Fontes de Financiamento para implementar o Plano de Negócio
        </legend>
        <div className="bx--form__helper-text">
          [Tomando em conta as fontes de capital disponíveis para implementação
          do seu Plano de Negócio, especifique o montante que espera obter de
          cada uma delas, em Meticais.{" "}
          <strong>
            Apenas preencha o campo referente a “fundos próprios” e “outras
            fontes” se tiver evidências de disponibilidade para uso no âmbito da
            CPN. Essas evidências ser-lhe-ão solicitadas posteriormente.
          </strong>
          ]
        </div>
        <Row className="mt-1">
          <Column sm={12} md={4} lg={4} className="required">
            <TextInput
              id="ownFunds"
              labelText="Fundos próprios,  montante (MZN)"
              disabled={disabled}
              {...register("ownFunds")}
            />
            <p className="field-error">{errors.ownFunds?.message}</p>
          </Column>
          <Column sm={12} md={4} lg={4} className="required">
            <TextInput
              id="requestedFunds"
              labelText="Fundos a solicitar na CPN, montante (não superior a 1.500.000 MZN)"
              disabled={disabled}
              {...register("requestedFunds")}
            />
            <p className="field-error">{errors.requestedFunds?.message}</p>
          </Column>
          <Column sm={12} md={4} lg={4} className="required">
            <TextInput
              id="otherFunds"
              labelText="Outras fontes (empréstimos etc.),  montante (MZN)"
              disabled={disabled}
              {...register("otherFunds")}
            />
            <p className="field-error">{errors.otherFunds?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

BusinessPlanIdeaForm.defaultProps = {
  disabled: false,
};

export default BusinessPlanIdeaForm;
